exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods-service-wrapper[data-v-64264406] {\n  padding: 0;\n}\n.search-table[data-v-64264406] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n.filter-group[data-v-64264406] {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.pagination-wrapper[data-v-64264406] {\n  margin-top: 15px;\n  display: flex;\n  justify-content: center;\n}\n", ""]);

// exports
